import { IosShareRounded, Search } from "@mui/icons-material";
import BookmarkButton from "./BookmarkButton";
import SpeedActions from "./SpeedActions";
import { getDateString } from "./timeHelper";
import { ChevronRight, ChevronRightRounded } from "@material-ui/icons";

const TrackActions = ({
    authenticated,
    onPodcastClick,
    onShareClick,
    onSpeedClick,
    setOpenSearchTranscript,
    showLabels,
    track,
}) => {
    const shareIconStyle = {
        fontSize: '21px',
        marginBottom: '-18px',
    }

    const bookmarkIconStyle = {
        fontSize: '22px',
        marginBottom: '-20px',
    }

    const searchIconStyle = {
        fontSize: '22px',
        marginBottom: '-20px',
    }

    return !track ? <></>
        : <div>
            <div>


                <table style={{ padding: '10px 16px 16px', borderBottom: '1px solid rgb(224, 224, 224)', }}>
                    <tbody>
                        <tr>
                            <td style={{ paddingRight: '16px' }}>
                                <button onClick={onPodcastClick}>
                                    <img src={track.source.imageURL} className='sourceImage' style={{ marginBottom: '6px', width: '44px', height: '44px' }} />
                                </button>
                            </td>
                            <td style={{ width: '100%' }}>
                                <button onClick={onPodcastClick} style={{ textAlign: 'left' }}>
                                    <div className='sourceName'>
                                        {track.source.name}
                                    </div>
                                </button>
                            </td>
                            <td style={{ paddingLeft: '16px' }}>
                                <ChevronRightRounded style={{ color: 'rgba(0, 0, 0, 0.5)', fontSize: '30px' }} />
                            </td>
                        </tr>
                    </tbody>
                </table>

                <SpeedActions onSpeedClick={onSpeedClick}/>

                <table style={{ borderSpacing: 0, width: '100%', textAlign: 'center'  }}>
                    <tbody>
                        <tr>
                            {!track.aiFeatures ? <></> :
                                <td style={{ width: '33%' }}>
                                    <button onClick={() => { setOpenSearchTranscript(true); }} className='trackOverviewActionButton'>
                                        <div className='trackOverviewActionIcon'>
                                            <Search style={searchIconStyle} />
                                        </div>
                                        <span style={{ display: showLabels ? 'inline' : 'none' }}>
                                            Search
                                        </span>
                                    </button>
                                </td>
                            }


                            <td style={{ width: '34%' }}>
                                <button onClick={onShareClick} className='trackOverviewActionButton'>
                                    <div className='trackOverviewActionIcon'>
                                        <IosShareRounded style={shareIconStyle} />
                                    </div>
                                    <span style={{ display: showLabels ? 'inline' : 'none' }}>
                                        Share
                                    </span>
                                </button>
                            </td>
                            {!authenticated ? <></> :
                                <td style={{ width: '33%' }}>
                                    <BookmarkButton
                                        trackId={track.fullTrackId ?? track.id}
                                        buttonClassName='trackOverviewActionButton'
                                        iconClassName={showLabels ? 'trackOverviewActionIcon' : ''}
                                        iconStyle={bookmarkIconStyle} />
                                </td>
                            }
                        </tr>
                    </tbody>
                </table>


            </div>
        </div>;
};

export default TrackActions;

